var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82847 7.64746L11.5755 12.7675C11.7586 12.9305 11.9953 13.0206 12.2405 13.0206C12.4857 13.0206 12.7223 12.9305 12.9055 12.7675L18.6535 7.64746H5.82847ZM20.2305 8.92046L14.2365 14.2615C13.6869 14.7512 12.9766 15.0218 12.2405 15.0218C11.5044 15.0218 10.794 14.7512 10.2445 14.2615L4.23047 8.90146V17.6475H20.2305V8.92046ZM4.23047 5.64746H20.2305C20.7609 5.64746 21.2696 5.85817 21.6447 6.23325C22.0198 6.60832 22.2305 7.11703 22.2305 7.64746V17.6475C22.2305 18.1779 22.0198 18.6866 21.6447 19.0617C21.2696 19.4367 20.7609 19.6475 20.2305 19.6475H4.23047C3.70004 19.6475 3.19133 19.4367 2.81626 19.0617C2.44118 18.6866 2.23047 18.1779 2.23047 17.6475V7.64746C2.23047 7.11703 2.44118 6.60832 2.81626 6.23325C3.19133 5.85817 3.70004 5.64746 4.23047 5.64746V5.64746Z",
    fill: "#697077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.65f6ef4e2131f69d3d7065f7ef1dd0e1.svg";
export { ForwardRef as ReactComponent };